var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10V11.5C18.19 11.5 20.09 15.05 18.33 17.71L17.24 16.62C18.06 14.96 16.85 13 15 13V14.5L12.75 12.25L15 10ZM15 21V19.5C11.81 19.5 9.91 15.95 11.67 13.29L12.76 14.38C11.94 16.04 13.15 18 15 18V16.5L17.25 18.75L15 21ZM16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H11C10.36 19.45 9.86 18.77 9.5 18H2V8H16V9.59C16.71 9.7 17.39 9.94 18 10.31V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM16 6H2V4H16",
    fill: "#00234B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSync);
export default __webpack_public_path__ + "static/media/calendar-sync.ba7620629b85aa22079121b564c27824.svg";
export { ForwardRef as ReactComponent };